<template>
  <section class="p-cloundmonitor">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="monitor-wrap">
        <section class="c-mt-84 monitor-title">
          <p class="c-fs-32 c-mb c-fw-b c-c-text-color-dark">混合云监控系统</p>
          <p class="c-fs-16 c-mt-36 c-mb-56 c-lh-38 c-ta-j">当前 IT 基础设施环境大多存在多地多中心，公有云、私有云、虚拟化、传统的数据中心的并存的情况，如果将这些资产统一到一个平台进行统一监控管理，
            难度很大，MonitorWay 混合云监控系统可以将混合云的资产与现有的 IT 基础设置统一到统一平台进行监控监控管理，大大的提高了运维的效率。</p>
          <img src="../../assets/monitor/clound.jpg" class="c-cs-p" preview="monitor-clound"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-84">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">MonitorWay 混合云监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-14 c-c-text-grey c-lh-36 c-mt-40 c-pt-56 c-pl-92 c-pb-128 c-p-r">
            <ul>
              <li>支持阿里云、腾讯云、AWS、Aruze 等主流公有云接口</li>
              <li>通过无代理的方式快速获取公有云平台的资产和性能数据</li>
              <li>与现有的智能运维平台的其他资产进行统一管理</li>
            </ul>
            <img src="../../assets/monitor/clound-pic.png" class="c-pr-40 pic">
          </div>
        </section>
        <section class="c-pb-164 features">
          <div class="c-d-f c-ai-c c-mt-80">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">功能介绍</span>
          </div>
          <div class="c-d-f c-jc-sb c-fw-w c-mt-40 features-wrap">
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/clound1.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">公有云API接口</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">可通过阿里云、腾讯云、AWS、Aruze 的官方平台开放的 API，进行数据的获取与展现，仅需要输入公有云厂商的数据抓取的验证信息，即可快速批量获取公有云资产。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip4.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">统一的报表预警</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">与 MonitorWay 智能运维平台系统进行无缝的集成，可以统一报表和预警功能，以达到提升管理效率的目标。</p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width monitor-wrap-mobile">
        <section class="c-mt-40 monitor-title">
          <p class="c-fs-19 c-fw-b c-c-text-color-dark">混合云监控系统</p>
          <p class="c-fs-12 c-mt-16 c-mb-24 c-lh-22 c-ta-j">当前 IT 基础设施环境大多存在多地多中心，公有云、私有云、虚拟化、传统的数据中心的并存的情况，如果将这些资产统一到一个平台进行统一监控管理，
            难度很大，MonitorWay 混合云监控系统可以将混合云的资产与现有的 IT 基础设置统一到统一平台进行监控监控管理，大大的提高了运维的效率。
          </p>
          <img src="../../assets/monitor/clound.jpg" preview="monitor-clound1"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">MonitorWay 混合云监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-13 c-c-text-grey c-lh-28 c-mt-24 c-ptb-20 c-pl-36 c-pr-16 c-boxshadow">
            <ul>
              <li>支持阿里云、腾讯云、AWS、Aruze 等主流公有云接口</li>
              <li>通过无代理的方式快速获取公有云平台的资产和性能数据</li>
              <li>与现有的智能运维平台的其他资产进行统一管理</li>
            </ul>
          </div>
        </section>
        <section class="features">
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">功能介绍</span>
          </div>
          <div class="c-mt-24 features-wrap">
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/clound1.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">公有云API接口</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">可通过阿里云、腾讯云、AWS、Aruze 的官方平台开放的API，进行数据的获取与展现，仅需要输入公有云厂商的数据抓取的验证信息，即可快速批量获取公有云资产。</p>
                </div>
              </div>
            </div>
            <div class="features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/ip4.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">统一的报表预警</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">与 MonitorWay 智能运维平台系统进行无缝的集成，可以统一报表和预警功能，以达到提升管理效率的目标。</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'clound',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.p-cloundmonitor {
  @media screen and (min-width: 1180px) {
    min-height: calc(100vh - 90px - 525px);
    background: url('../../assets/monitor/monitor-bg.png') no-repeat;
    background-position: bottom;
    background-size: 100%;
  }
  .monitor-wrap {
    width: 1180px;
    margin: 0 auto;
    .monitor-title {
      img {
        height: 417px;
      }
    }
    .pic {
      position: absolute;
      right: 0;
      top: -105px;
    }
    .features {
      .features-wrap {
        .features-item {
          width: calc(50% - 7px);
          padding: 44px 54px;
          margin-bottom: 14px;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          border-radius: 1px;
          img {
            width: 18%;
          }
        }
      }
    }
  }
  .monitor-wrap-mobile {
    .monitor-title {
      img {
        // height: 202px;
        width: 100%;
      }
    }
    .features {
      .features-wrap {
        padding-bottom: 40px;
        .features-item {
          width: 100%;
          padding: 25px 16px;
          background: white;
          text-align: justify;
          img {
            width: 38px;
            height: 38px;
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>
